import type { ColumnDef } from "@tanstack/react-table";

import { DataTableColumnHeader } from "@/lib/data-table-column-header";
import type { Supplier } from "@/types";

export const columns: ColumnDef<Supplier>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nombre" />
    ),
    enableSorting: false,
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "city",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Ciudad" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const city = row.original.city;
      return city ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "phone",
    header: "Teléfono",
    enableSorting: false,
    cell: ({ row }) => {
      const phone = row.original.phone;
      return phone ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "category_name",
    id: "category_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Categoría" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const category = row.original.category;
      return category ? (
        <span>{category.name}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "subcategory_name",
    id: "subcategory_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Subcategoría" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const subcategory = row.original.subcategory;
      return subcategory ? (
        <span>{subcategory.name}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
];
